import { FormattingService } from 'src/app/core/services/formatting.service';
import { Component, OnInit, OnDestroy, Input, EventEmitter, Output, ViewChild, ElementRef } from '@angular/core';
import { Subject } from 'rxjs';
import { UntypedFormControl } from '@angular/forms';

@Component({
    selector: 'app-value-input',
    templateUrl: './value-input.component.html',
    styleUrls: ['./value-input.component.scss'],
    standalone: false
})
export class ValueInputComponent implements OnInit, OnDestroy {
  ngUnsubscribe = new Subject<boolean>();

  _value: string;
  @Input() get value() {
    return this._value;
  }
  set value(val) {
    this._value = val;
    if (this.formatDisplayValueAfterInput) {
      this.formatDisplayValue();
    }
    else {
      this.displayValue = this._value;
    }
  }
  @Output() valueChange = new EventEmitter<string>();

  @Input()
  decimals = 0;

  @Input()
  isDisabled = false;

  @Input()
  inputId: string;

  @Input()
  description: string;

  @Input()
  canAcceptNegativeValues = true;

  @Input()
  isCurrency: boolean;

  @Input()
  formatDisplayValueAfterInput: boolean = true;

  @Input() control: UntypedFormControl;
  @Input() errorMessage = '';

  multiplier: number;
  displayValue: string;
  isEditing: boolean;
  shouldRenderForReactiveForms: boolean;
  @ViewChild('editInput') editInput: ElementRef;
  constructor(private readonly formattingService: FormattingService) { }

  ngOnInit() {
    if (this.control) {
      this.shouldRenderForReactiveForms = true;
      this.value = this.control.value;
    }

    if (this.formatDisplayValueAfterInput) {
      this.formatDisplayValue()
    }
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next(true);
    this.ngUnsubscribe.complete();
  }

  onKeyUp() {
    if (this.value && this.value.length) {
      const valueNumber = this.value.replace(',', '.');
      const decimalPart = valueNumber.split('.')[1];
      if (decimalPart && decimalPart.length > this.decimals) {
        this.value = this.getTruncatedFixed(+valueNumber, this.decimals);
      }
      this.valueChange.emit(this.value);
    } else {
      this.valueChange.emit(null);
    }
  }

  getTruncatedFixed(value: number, decimals: number) {
    if (value >= 0) {
      return (Math.floor(value * Math.pow(10, decimals)) / Math.pow(10, decimals)).toFixed(decimals);
    } else {
      return (Math.ceil(value * Math.pow(10, decimals)) / Math.pow(10, decimals)).toFixed(decimals);
    }
  }

  onFocusIn() {
    this.isEditing = true;
    if (this.formatDisplayValueAfterInput) {
      this.value = this.formattingService.getDisplayFormattedNumber(this.value, this.isCurrency);
      this.value = this.formattingService.removeThousandSeparators(this.value);
    }
    setTimeout(() => {
      this.editInput.nativeElement.focus();
    });
  }

  onFocusOut() {
    this.isEditing = false;
    if (this.formatDisplayValueAfterInput) {
      this.formatDisplayValue();
    }
    this.value = this.formattingService.getNumber(this.value);
    this.valueChange.emit(this.value);
  }

  formatDisplayValue() {
    this.displayValue = this.formattingService.getDisplayFormattedNumber(this.value, this.isCurrency);
  }
}
